import { Card } from '../../components/ui';

// Renders the summary cards row above each explorer's table.
// Picks the right cards based on which fields are present.
export function SummaryRow({ summary }) {
  if (!summary) return null;
  return (
    <div style={{ display: 'flex', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
      <Card label="Total" value={summary.total} />
      {summary.in_both != null              && <Card label="Matched (DF+NS)"      value={summary.in_both}         color="#155724" />}
      {summary.unmatched != null            && <Card label="Unmatched (DF+NS)"    value={summary.unmatched}       color="#dc3545" />}
      {summary.df_only != null              && <Card label="Dayforce Only"        value={summary.df_only}         color="#856404" />}
      {summary.ns_only != null              && <Card label="NetSuite Only"        value={summary.ns_only}         color="#856404" />}
      {summary.with_punches != null         && <Card label="With Punches"         value={summary.with_punches}    color="#0d47a1" />}
      {summary.total_punches != null        && <Card label="Total Punches"        value={summary.total_punches.toLocaleString()} color="#e65100" />}
      {summary.with_labor_metrics != null   && <Card label="With Labor Metrics"   value={summary.with_labor_metrics}   color="#1b5e20" />}
      {summary.with_map_419 != null         && <Card label="With Map 419"         value={summary.with_map_419}         color="#0d47a1" />}
      {summary.total_map_419_entries != null && <Card label="Total Map 419 Entries" value={summary.total_map_419_entries.toLocaleString()} color="#e65100" />}
      {summary.with_ns_mapping != null      && <Card label="With NS Mapping"      value={summary.with_ns_mapping}      color="#155724" />}
      {summary.without_ns_mapping != null   && <Card label="Without NS Mapping"   value={summary.without_ns_mapping}   color="#856404" />}
      {summary.unique_tasks != null         && <Card label="Unique Labor Metrics" value={summary.unique_tasks}         color="#0d47a1" />}
      {summary.unique_sites != null         && <Card label="Unique Locations"     value={summary.unique_sites}         color="#e65100" />}
      {summary.type_counts && Object.entries(summary.type_counts).map(([t, c]) => (
        <Card key={t} label={t} value={c} color="#4a148c" />
      ))}
    </div>
  );
}
